import DEFAULT from '..'
import { PartnerConfig } from '@/types'
import {
  familyMemberGenderField,
  familyMemberDateOfBirthField,
} from '../fieldLists'

const MinimumConfigFlow = (): PartnerConfig => ({
  branding: {
    logo: [
      {
        src: '/images/babylon.png',
        alt: 'Babylon logo config',
      },
    ],
  },
  config: {
    name: 'Default Minimum Flow',
    appName: DEFAULT.APPNAMES.BABYLON,
    acceptLanguage: 'en-GB',
    useDnaV2Design: false,
    codes: {
      membership: 'MY-MEMBERSHIP-CODE',
    },
    partnerUrlSlug: 'regression-minimum-flow',
    steps: [
      {
        slug: 'welcome-test-minimum',
        component: 'welcome',
      },
      {
        slug: 'registration-test-minimum',
        component: 'registration',
      },
      {
        slug: 'thank-you-test-minimum',
        component: 'summary',
      },
    ],
    fields: [
      [DEFAULT.FIELDS.EMAIL],
      [
        DEFAULT.FIELDS.FIRST_NAME,
        DEFAULT.FIELDS.LAST_NAME,
        DEFAULT.FIELDS.PASSWORD,
        DEFAULT.FIELDS.DATE_OF_BIRTH,
      ],
      [
        DEFAULT.FIELDS.FIRST_NAME,
        DEFAULT.FIELDS.LAST_NAME,
        familyMemberGenderField,
        familyMemberDateOfBirthField,
      ],
    ],
  },
  content: {
    'en-GB': {
      steps: [
        {
          title: 'Enter your email address [en-GB]',
          stepperLabel: 'Welcome',
          copy: [],
          productFeatures: [
            {
              icon: 'ChatFilled',
              title: 'Check your symptoms quickly and easily',
            },
            {
              icon: 'PeopleMedicalSpecialist',
              title: 'Talk to a doctor, 24/7',
            },
            {
              icon: 'Medication',
              title: 'Prescriptions sent to a local pharmacy of your choice',
            },
          ],
        },
        {
          title: 'Register',
          stepperLabel: 'Registration',
          copy: ['Add a few details to access 24/7 health support'],
        },
        {
          title: 'Download the app',
          stepperLabel: 'Thank You',
          copy: [
            'Download and sign in to the app to book a Babylon video appointment 24/7.',
          ],
          imgUrl: '/images/babylon-ios-app.png',
          dnaV2DesignImgUrl: '/images/babylon-ios-app.png',
        },
      ],
      footerLinks: DEFAULT.FOOTERLINKS.GBR,
    },
    'es-US': {
      steps: [
        {
          title: 'Enter your email address [es-US]',
          stepperLabel: 'Welcome [es-US]',
          copy: [],
          productFeatures: [
            {
              icon: 'ChatFilled',
              title: 'Check your symptoms quickly and easily [es-US]',
            },
            {
              icon: 'PeopleMedicalSpecialist',
              title: 'Talk to a doctor, 24/7 [es-US]',
            },
            {
              icon: 'Medication',
              title:
                'Prescriptions sent to a local pharmacy of your choice [es-US]',
            },
          ],
        },
        {
          title: 'Register [es-US]',
          stepperLabel: 'Registration [es-US]',
          copy: ['Add a few details to access 24/7 health support'],
        },
        {
          title: 'Download the app [es-US]',
          stepperLabel: 'Thank You [es-US]',
          copy: [
            'Download and sign in to the app to book a Babylon video appointment 24/7. [es-US]',
          ],
          imgUrl: '/images/babylon-ios-app.png',
          dnaV2DesignImgUrl: '/images/babylon-ios-app.png',
        },
      ],
      footerLinks: DEFAULT.FOOTERLINKS.GBR,
    },
  },
})

export default MinimumConfigFlow
